import { render, staticRenderFns } from "./InvoiceContainer.vue?vue&type=template&id=36be6162&"
import script from "./InvoiceContainer.vue?vue&type=script&lang=js&"
export * from "./InvoiceContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports